// extracted by mini-css-extract-plugin
export default {"divider":"styles_divider__ELtvB","tag":"styles_tag__4SlRY","selected_tag":"styles_selected_tag__Zpxul"};